var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0D8AFF;}\n\t.st1{fill:none;stroke:#0D8AFF;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,51.5h-35c-2.8,0-5.2-2.3-5.3-5.1L2.5,18.5C2.4,16.9,3,15.3,4,14.1c1-1,2.3-1.6,3.7-1.6h38.6 c1.4,0,2.7,0.6,3.7,1.6c1.1,1.1,1.6,2.8,1.5,4.4l-1.6,27.8C49.7,49.2,47.3,51.5,44.5,51.5z M7.8,14.5c-0.9,0-1.7,0.4-2.3,1 c-0.7,0.7-1.1,1.8-1,2.9l1.6,27.8c0.1,1.8,1.6,3.3,3.4,3.3h35c1.8,0,3.3-1.5,3.4-3.3l1.6-27.8c0.1-1.1-0.3-2.2-1-2.9 c-0.6-0.6-1.4-1-2.3-1H7.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,15l0.7-4.9c0.5-2.6,3.5-4.9,6.8-4.6h26.7c3.3-0.3,6.4,2,6.9,4.6l0.8,4.2l2.4,1l-1.1-5.7 c-0.7-3.7-4.7-6.4-9-6.2H13.2C8.8,3.3,4.9,6,4.2,9.7l-1.1,7L5.6,15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 17.8,
    y1: 32.4,
    x2: 25.2,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 25.2,
    y1: 39.8,
    x2: 41.5,
    y2: 23.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskArchive);
export default __webpack_public_path__ + "static/media/task_archive.e31246ee46ceeb6529dd9cfae9265333.svg";
export { ForwardRef as ReactComponent };